import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    paper: {
      margin: theme.spacing(2),
    },
  })
)
